import React from 'react';
interface MediaPlaceholderProps {
  type: 'image' | 'video' | 'gallery';
  title: string;
  description?: string;
  imageUrl?: string;
}
export function MediaPlaceholder({
  title,
  description,
  imageUrl
}: MediaPlaceholderProps) {
  // Only render when there is an actual image to show
  if (!imageUrl) return null;
  return <figure className="my-6 overflow-hidden rounded-xl border bg-card shadow-sm" data-id="element-245">
      {(title || description) && <figcaption className="border-t bg-muted/30 px-5 py-3" data-id="element-246">
          <div className="text-sm font-semibold text-foreground" data-id="element-247">{title}</div>
          {description && <div className="mt-0.5 text-xs text-muted-foreground" data-id="element-248">
              {description}
            </div>}
        </figcaption>}
    </figure>;
}